import {PAGES, ROUTE_NAMES} from "../core/consts";

export const GAME_ROUTE_PARAM = 'match';

export const VIEW_TYPE_FILTERS = {
  carousel: 'carousel',
  slider: 'slider',
  featuredList: 'featured-list'
};

export const CALCULATORS_FILTERS = {
  oddsConvertor: 'oddsConvertor',
  payoutCalculator: 'PayoutCalculator',
  arbitrageCalculator: 'ArbitrageCalculator'
};

export const ACCUMULATOR_FILTERS = {
  auto: 'auto',
  manually: 'manually',
};

export const LANDING_PAGE = {
  ITEMS: {
    featuredGames: true,
    entityStats: true,
    ad: true,
    prediction: true,
    plTop: true,
    plMiddle: true,
    plBottom: true,
    standingsPreview: true,
    topCompetitions: true,
    mySelections: true,
    catalog: true,
    topCompetitors: true,
    entityDescription: true,
    news: true,
    trends: true,
    topTrends: true,
    outrights: true,
    teamOfTheWeek: true,
    transfers: true,
    bestOdds: true,
    bookmakersReview: true,
    dba: true,
    recentForm: true,
    oddsBy: true,
    medals: true,
    matchesSlider: true,
    externalAd: true,
    highlights: true,
    relatedEntities: true
  },

  KEYS: {
    featuredGames: 'featuredGames',
    entityStats: 'entityStats',
    ad: 'ad',
    prediction: 'prediction',
    plTop: 'plTop',
    plMiddle: 'plMiddle',
    plBottom: 'plBottom',
    standingsPreview: 'standingsPreview',
    topCompetitions: 'topCompetitions',
    catalog: 'catalog',
    topCompetitors: 'topCompetitors',
    mySelections: 'mySelections',
    entityDescription: 'entityDescription',
    news: 'news',
    trends: 'trends',
    topTrends: 'topTrends',
    outrights: 'outrights',
    teamOfTheWeek: 'teamOfTheWeek',
    transfers: 'transfers',
    bestOdds: 'bestOdds',
    bookmakersReview: 'bookmakersReview',
    recentForm: 'recentForm',
    oddsBy: 'oddsBy',
    medals: 'medals',
    matchesSlider: 'matchesSlider',
    externalAd: 'externalAd',
    highlights: 'highlights',
    relatedEntities: 'relatedEntities',
  }
}

export const BETTING_PAGE = {
  FILTERS: {
    // eslint-disable-next-line
    ["pt-br"]: "/pt-br/apostas",
    // eslint-disable-next-line
    ["es-pe"]: "/es/apuestas-peru",
    // eslint-disable-next-line
    ["es-ar"]: "/es/apuestas-argentina",
    // eslint-disable-next-line
    ["es-co"]: "/es/apuestas-colombia",
    // eslint-disable-next-line
    ["es-cl"]: "/es/apuestas-chile/mundial",
    // eslint-disable-next-line
    ["es-mx"]: "/es-mx/apuestas-mexico"
  }
}

export const BETTING_DYNAMIC_PATH = {
  [ROUTE_NAMES.betting]: {
    // eslint-disable-next-line
    ["pt-br"]: "/apostas",
    // eslint-disable-next-line
    ["es-pe"]: "/apuestas-peru",
    // eslint-disable-next-line
    ["es-ar"]: "/apuestas-argentina",
    // eslint-disable-next-line
    ["es-co"]: "/apuestas-colombia",
    // eslint-disable-next-line
    ["es-cl"]: "/apuestas-chile",
    // eslint-disable-next-line
    ["es-mx"]: "/apuestas-mexico"
  },
  [PAGES.BETTING.bettingSites]: {
    // eslint-disable-next-line
    ["pt-br"]: "casas-de-apostas",
    // eslint-disable-next-line
    ["es-pe"]: "casas-de-apuestas",
    // eslint-disable-next-line
    ["es-ar"]: "casas-de-apuestas",
    // eslint-disable-next-line
    ["es-co"]: "casas-de-apuestas",
    // eslint-disable-next-line
    ["es-cl"]: "casas-de-apuestas",
    // eslint-disable-next-line
    ["es-mx"]: "casas-de-apuestas"
  },
  [PAGES.BETTING.howToBet]: {
    // eslint-disable-next-line
    ["pt-br"]: "como-apostar",
    // eslint-disable-next-line
    ["es-pe"]: "como-apostar",
    // eslint-disable-next-line
    ["es-ar"]: "como-apostar",
    // eslint-disable-next-line
    ["es-co"]: "como-apostar",
    // eslint-disable-next-line
    ["es-cl"]: "como-apostar",
    // eslint-disable-next-line
    ["es-mx"]: "como-apostar"
  }
}
